export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  categoryId: string;
  categoryName: string;
  publishedAt: string;
  updatedAt: string;
  readTime: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'a1',
    slug: 'latest-route-2026-july',
    title: '爱情岛一论坛2026年7月最新免费路线汇总',
    excerpt: '整理2026年7月爱情岛一论坛最新可用免费路线入口，包含多个备用地址，确保随时都能稳定访问论坛。',
    content: `<p>随着网络环境的不断变化，爱情岛一论坛的访问路线也在持续更新。本文整理了2026年7月最新可用的免费路线入口，帮助广大用户快速稳定地访问论坛。</p>
<h2>当前可用主路线</h2>
<p>以下是经过验证的最新可用路线入口。建议收藏本页面，我们会持续更新最新的访问地址。</p>
<h3>路线一：直连入口</h3>
<p>该路线为论坛官方推荐的直连方式，访问速度快，稳定性高。建议优先使用此路线进行访问。</p>
<h3>路线二：备用入口</h3>
<p>当主路线不可用时，可以使用备用入口。备用入口同样经过优化，确保访问体验不受影响。</p>
<h3>路线三：镜像站点</h3>
<p>镜像站点提供与主站完全一致的内容，适合在高峰期或主站维护期间使用。</p>
<h2>使用建议</h2>
<p>建议同时保存多个路线入口，以备不时之需。如果遇到访问问题，可以尝试切换不同路线。定期关注本页更新，获取最新可用路线信息。</p>
<h2>注意事项</h2>
<p>请使用正规渠道获取访问路线，避免使用来源不明的第三方链接。如发现路线无法访问，请及时反馈，我们会尽快更新。</p>`,
    categoryId: 'latest-routes',
    categoryName: '最新路线',
    publishedAt: '2026-07-28',
    updatedAt: '2026-08-01',
    readTime: 5,
    tags: ['最新路线', '免费入口', '2026年7月', '路线汇总'],
  },
  {
    id: 'a2',
    slug: 'backup-routes-guide',
    title: '爱情岛论坛备用路线使用指南——再也不怕找不到入口',
    excerpt: '详细讲解爱情岛论坛备用路线的使用方法和最佳实践，让你在主线不可用时依然畅通无阻。',
    content: `<p>很多用户在访问爱情岛论坛时，经常遇到主线不可用的情况。本文将详细介绍备用路线的使用方法，帮助你在任何时候都能顺利访问论坛。</p>
<h2>为什么要准备备用路线</h2>
<p>网络服务可能因各种原因出现不可用的情况，拥有备用路线可以确保你随时访问论坛。</p>
<h3>备用路线类型</h3>
<p>我们提供多种类型的备用路线，包括镜像站、加速节点、代理入口等，每种路线都有其适用场景。</p>
<h2>如何选择最佳路线</h2>
<p>根据你的网络环境和地理位置，选择最适合的访问路线。建议测试不同路线的响应速度，选择最快的那个。</p>
<h2>路线切换技巧</h2>
<p>掌握快速切换路线的技巧，可以在遇到访问问题时迅速恢复连接，不影响使用体验。</p>`,
    categoryId: 'latest-routes',
    categoryName: '最新路线',
    publishedAt: '2026-07-20',
    updatedAt: '2026-07-25',
    readTime: 4,
    tags: ['备用路线', '使用指南', '路线切换'],
  },
  {
    id: 'a3',
    slug: 'mobile-access-tutorial',
    title: '手机端访问爱情岛一论坛完整教程（iOS & Android）',
    excerpt: '针对手机用户的操作指南，涵盖iOS和Android两大平台，图文并茂教你手机端访问论坛。',
    content: `<p>越来越多用户习惯使用手机访问论坛。本文提供iOS和Android两大平台的完整访问教程，让你随时随地畅游论坛。</p>
<h2>iOS设备访问教程</h2>
<p>iPhone和iPad用户可以通过以下步骤快速设置并访问论坛。操作简单，一次配置长期使用。</p>
<h3>第一步：浏览器选择</h3>
<p>推荐使用Safari或Chrome浏览器，确保浏览器版本为最新。</p>
<h3>第二步：访问设置</h3>
<p>按照指引完成基础设置，即可流畅访问论坛所有功能。</p>
<h2>Android设备访问教程</h2>
<p>Android用户同样可以通过简单步骤完成配置。支持主流浏览器和多种访问方式。</p>
<h2>常见问题</h2>
<p>如果在手机端遇到访问问题，可以查看常见问题部分获取解决方案。</p>`,
    categoryId: 'access-tutorials',
    categoryName: '访问教程',
    publishedAt: '2026-07-15',
    updatedAt: '2026-07-30',
    readTime: 7,
    tags: ['手机访问', 'iOS', 'Android', '移动端教程'],
  },
  {
    id: 'a4',
    slug: 'pc-browser-setup',
    title: '电脑端浏览器设置教程——最佳访问配置方案',
    excerpt: '针对电脑端用户的详细配置教程，涵盖Chrome、Edge、Firefox等主流浏览器的最佳设置方案。',
    content: `<p>电脑端访问论坛的用户占大多数。本文将介绍各大主流浏览器的最佳配置方案，确保访问速度和稳定性。</p>
<h2>Chrome浏览器配置</h2>
<p>Chrome是全球使用最广泛的浏览器，优化Chrome设置可以显著提升访问体验。</p>
<h2>Edge浏览器配置</h2>
<p>微软Edge浏览器基于Chromium内核，与Chrome类似的配置方法，性能表现同样出色。</p>
<h2>Firefox浏览器配置</h2>
<p>Firefox用户可以参考专属配置方案，实现最佳访问效果。</p>
<h2>通用优化建议</h2>
<p>除了浏览器配置外，还有一些通用的优化建议可以进一步提升访问体验。</p>`,
    categoryId: 'access-tutorials',
    categoryName: '访问教程',
    publishedAt: '2026-07-10',
    updatedAt: '2026-07-22',
    readTime: 6,
    tags: ['电脑端', '浏览器', '配置教程', 'Chrome'],
  },
  {
    id: 'a5',
    slug: 'speed-optimization-tips',
    title: '提升论坛访问速度的5个实用技巧',
    excerpt: '分享提升爱情岛论坛访问速度的实用技巧，让你的论坛浏览体验更加流畅。',
    content: `<p>访问速度直接影响论坛使用体验。本文分享5个经过验证的实用技巧，帮助你显著提升访问速度。</p>
<h2>技巧一：DNS优化</h2>
<p>选择合适的DNS服务器可以加快域名解析速度，从而提升整体访问速度。</p>
<h2>技巧二：缓存策略</h2>
<p>合理利用浏览器缓存机制，减少重复加载，加快页面打开速度。</p>
<h2>技巧三：网络环境优化</h2>
<p>优化你的网络环境设置，选择最佳的连接方式。</p>
<h2>技巧四：时段选择</h2>
<p>避开访问高峰期，选择网络较为空闲的时段访问，可以获得更快的速度。</p>
<h2>技巧五：路线优选</h2>
<p>在不同路线中选择响应最快的进行访问，动态调整确保最佳体验。</p>`,
    categoryId: 'usage-tips',
    categoryName: '使用技巧',
    publishedAt: '2026-07-05',
    updatedAt: '2026-07-28',
    readTime: 4,
    tags: ['速度优化', '实用技巧', '访问加速'],
  },
  {
    id: 'a6',
    slug: 'hidden-features',
    title: '爱情岛论坛隐藏功能介绍——你可能不知道的实用功能',
    excerpt: '挖掘论坛中不为人知的隐藏功能和快捷操作，让你成为论坛使用高手。',
    content: `<p>论坛中有许多隐藏的实用功能，掌握了这些功能，你的使用体验将会大幅提升。</p>
<h2>快捷操作</h2>
<p>掌握键盘快捷键和其他快捷操作方式，提升浏览效率。</p>
<h2>个性化设置</h2>
<p>论坛提供了丰富的个性化设置选项，根据自己喜好定制界面和功能。</p>
<h2>高级搜索技巧</h2>
<p>学会使用高级搜索功能，快速找到你需要的内容。</p>
<h2>数据管理</h2>
<p>了解如何管理你的论坛数据，包括收藏、历史记录等。</p>`,
    categoryId: 'usage-tips',
    categoryName: '使用技巧',
    publishedAt: '2026-06-28',
    updatedAt: '2026-07-18',
    readTime: 5,
    tags: ['隐藏功能', '高级技巧', '快捷操作'],
  },
  {
    id: 'a7',
    slug: 'connection-issues-fix',
    title: '无法访问论坛？常见连接问题及解决方案汇总',
    excerpt: '整理论坛访问中常见的连接问题及对应解决方案，自助排查快速恢复访问。',
    content: `<p>访问论坛时可能遇到各种连接问题，本文汇总了最常见的几种情况及对应的解决方案。</p>
<h2>问题一：页面无法加载</h2>
<p>当页面无法加载时，首先检查网络连接状态，然后按照以下步骤逐一排查。大多数情况下，刷新页面或更换路线即可解决。</p>
<h2>问题二：加载速度慢</h2>
<p>访问速度慢可能与网络环境、访问时段、所选路线有关。尝试切换路线或避开高峰期访问。</p>
<h2>问题三：部分功能不可用</h2>
<p>如果论坛部分功能无法正常使用，可能是浏览器兼容性问题。尝试更新浏览器或更换浏览器。</p>
<h2>问题四：频繁断线</h2>
<p>频繁断线通常与网络稳定性有关，建议检查网络连接质量并选择合适的访问路线。</p>`,
    categoryId: 'faq',
    categoryName: '常见问题',
    publishedAt: '2026-06-20',
    updatedAt: '2026-07-15',
    readTime: 5,
    tags: ['连接问题', '故障排查', '解决方案'],
  },
  {
    id: 'a8',
    slug: 'account-security-guide',
    title: '论坛账号安全指南——保护你的账号不被盗用',
    excerpt: '账号安全不容忽视，本文分享论坛账号保护的最佳实践和安全设置建议。',
    content: `<p>账号安全是每个论坛用户都应该重视的问题。本文将介绍如何保护你的论坛账号安全。</p>
<h2>强密码设置</h2>
<p>设置一个强密码是保护账号安全的第一步。建议使用包含大小写字母、数字和特殊字符的复杂密码。</p>
<h2>定期更换密码</h2>
<p>定期更换密码可以有效降低账号被盗风险，建议每3个月更换一次。</p>
<h2>不要共享账号</h2>
<p>避免与他人共享账号，即使是信任的朋友也可能带来安全隐患。</p>
<h2>警惕钓鱼链接</h2>
<p>不要点击来源不明的链接，谨防钓鱼网站盗取账号信息。</p>`,
    categoryId: 'faq',
    categoryName: '常见问题',
    publishedAt: '2026-06-15',
    updatedAt: '2026-07-10',
    readTime: 3,
    tags: ['账号安全', '密码保护', '安全指南'],
  },
  {
    id: 'a9',
    slug: 'newbie-quick-start',
    title: '新手快速上手指南——5分钟学会使用爱情岛论坛',
    excerpt: '专为新用户准备的快速入门教程，从注册到发帖，一站式新手引导。',
    content: `<p>欢迎来到爱情岛论坛！如果你是第一次使用，这篇快速上手指南将帮助你迅速熟悉论坛的各项功能。</p>
<h2>注册账号</h2>
<p>注册过程简单快捷，只需提供基本信息即可完成注册。建议使用常用邮箱进行注册。</p>
<h2>完善个人资料</h2>
<p>注册完成后，建议完善个人资料，包括头像、昵称、个人简介等。</p>
<h2>浏览版块</h2>
<p>论坛分为多个版块，每个版块有不同主题。根据自己的兴趣选择浏览。</p>
<h2>发帖与回复</h2>
<p>了解发帖和回复的基本操作，开始参与论坛讨论。</p>
<h2>关注与收藏</h2>
<p>学会关注感兴趣的版块和收藏有用帖子，方便后续查看。</p>`,
    categoryId: 'access-tutorials',
    categoryName: '访问教程',
    publishedAt: '2026-06-10',
    updatedAt: '2026-07-05',
    readTime: 6,
    tags: ['新手教程', '快速上手', '入门指南'],
  },
  {
    id: 'a10',
    slug: 'route-update-log',
    title: '2026年路线更新日志——所有变更记录一览',
    excerpt: '记录2026年所有路线变更和更新，方便用户了解最新动态和历史变更。',
    content: `<p>我们持续跟踪并更新论坛访问路线，本文记录了2026年所有路线的变更情况。</p>
<h2>2026年7月更新</h2>
<p>本月新增2条备用路线，优化了主路线的访问速度。部分旧路线已下线，请使用最新路线。</p>
<h2>2026年6月更新</h2>
<p>6月份对路线体系进行了全面升级，新增了镜像站点功能，提升了整体稳定性。</p>
<h2>2026年5月更新</h2>
<p>5月新增移动端专属优化路线，手机用户访问体验大幅提升。</p>
<h2>更早更新记录</h2>
<p>2026年第一季度共进行了5次路线更新，累计新增12条访问路线。</p>`,
    categoryId: 'latest-routes',
    categoryName: '最新路线',
    publishedAt: '2026-08-01',
    updatedAt: '2026-08-01',
    readTime: 4,
    tags: ['更新日志', '路线变更', '2026年'],
  },
  {
    id: 'a11',
    slug: 'night-mode-tips',
    title: '论坛夜间模式设置与使用技巧',
    excerpt: '介绍论坛夜间模式的开启方法和使用技巧，保护视力，提升夜间浏览体验。',
    content: `<p>夜间浏览论坛时，开启夜间模式可以有效减少屏幕蓝光对眼睛的伤害。本文介绍论坛夜间模式的设置方法。</p>
<h2>开启夜间模式</h2>
<p>在论坛设置中找到显示选项，开启夜间模式。不同设备的具体操作略有差异。</p>
<h2>自动切换设置</h2>
<p>设置自动切换时间，让论坛根据时间自动在日间和夜间模式之间切换。</p>
<h2>自定义配色</h2>
<p>如果默认的夜间模式配色不适合你，可以自定义调整颜色方案。</p>`,
    categoryId: 'usage-tips',
    categoryName: '使用技巧',
    publishedAt: '2026-06-05',
    updatedAt: '2026-07-02',
    readTime: 3,
    tags: ['夜间模式', '护眼', '个性化设置'],
  },
  {
    id: 'a12',
    slug: 'forum-rules-explained',
    title: '论坛规则详解——避免违规操作的完整指南',
    excerpt: '详细解读论坛各项规则制度，帮助新老用户了解论坛规范，避免因违规操作导致账号受限。',
    content: `<p>了解并遵守论坛规则是每个用户的基本责任。本文详细解读论坛的各项规则制度。</p>
<h2>基本行为规范</h2>
<p>论坛倡导文明交流，禁止发布违法、违规、不文明内容。尊重他人，理性讨论。</p>
<h2>发帖规则</h2>
<p>各版块有具体的发帖规范，发布内容前请先阅读对应版块的置顶规则帖。</p>
<h2>账号管理规则</h2>
<p>了解账号管理的相关规定，包括账号注册、使用、注销等方面的要求。</p>
<h2>违规处理</h2>
<p>违反论坛规则可能面临警告、禁言、封号等不同程度的处理，请务必遵守规则。</p>`,
    categoryId: 'faq',
    categoryName: '常见问题',
    publishedAt: '2026-05-28',
    updatedAt: '2026-06-20',
    readTime: 5,
    tags: ['论坛规则', '使用规范', '账号安全'],
  },
];

export const getArticlesByCategory = (categoryId: string): Article[] => {
  return articles.filter((a) => a.categoryId === categoryId);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getLatestArticles = (limit: number = 6): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()).slice(0, limit);
};

export const getRelatedArticles = (currentSlug: string, categoryId: string, limit: number = 3): Article[] => {
  return articles.filter((a) => a.categoryId === categoryId && a.slug !== currentSlug).slice(0, limit);
};